// Recovers from ChunkLoadError caused by a stale tab requesting a route
// chunk (e.g. static/js/3263.<hash>.chunk.js) whose hash no longer exists
// because a newer build was deployed. React.lazy() imports reject a promise
// in that case, and nothing in the tree catches it, so the whole SPA crashes.
//
// Fix: detect the failure globally and force a single reload so the tab
// picks up the new build's index.html/main.js. Guarded with sessionStorage
// so a genuinely broken deploy can't reload the tab in an infinite loop.

const RELOAD_FLAG = "kt-chunk-reload-attempted";

function isChunkLoadError(reason) {
  if (!reason) return false;
  const name = reason.name || "";
  const message = reason.message || String(reason);
  return (
    name === "ChunkLoadError" ||
    /Loading chunk [\w.-]+ failed/i.test(message) ||
    /Loading CSS chunk [\w.-]+ failed/i.test(message)
  );
}

function reloadOnce() {
  if (sessionStorage.getItem(RELOAD_FLAG)) return;
  sessionStorage.setItem(RELOAD_FLAG, "1");
  window.location.reload();
}

export function registerChunkErrorRecovery() {
  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event.error)) reloadOnce();
  });
  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) reloadOnce();
  });
}

// Once the app has successfully rendered on the new build, clear the flag
// so a future deploy can still trigger a recovery reload for this tab.
export function clearChunkReloadFlag() {
  sessionStorage.removeItem(RELOAD_FLAG);
}
